<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
	export default {
		created() {
			this.$local.set('modalIds', []);
		}
	}
</script>

<style lang="scss">
	@import "./assets/css/reset.css";
	@import '@/assets/css/common.scss';
</style>
